import { ProtectedRoute } from './ProtectedRoute';
import { StaffLayout } from './StaffLayout';

export default function ProtectedStaffLayout() {
  return (
    <ProtectedRoute>
      <StaffLayout />
    </ProtectedRoute>
  );
}
